export default __webpack_public_path__ + "static/media/idea-title-2.66f9d8fc.png";